import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR';
import * as serviceWorker from './serviceWorker';
import Routes from './routes';
import 'antd/dist/antd.css';
import './index.css';


ReactDOM.render(
  (
    <ConfigProvider locale={ptBR}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </ConfigProvider>
  ),
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
